var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentLifeSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 29,
    viewBox: "0 0 44 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3493 13.83H4.88743C4.4121 13.83 4.02539 13.4433 4.02539 12.9679V0.862055C4.02539 0.386715 4.4121 0 4.88743 0H40.3493C40.8246 0 41.2113 0.386715 41.2113 0.862055V12.9679C41.2113 13.4433 40.8246 13.83 40.3493 13.83ZM4.88743 0.102776C4.46878 0.102776 4.12816 0.443398 4.12816 0.862055V12.9679C4.12816 13.3866 4.46878 13.7272 4.88743 13.7272H40.3493C40.7679 13.7272 41.1085 13.3866 41.1085 12.9679V0.862055C41.1085 0.443398 40.7679 0.102776 40.3493 0.102776H4.88743Z",
    fill: "url(#paint0_linear_1813_120624)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.732 28.293H0V28.3795H43.732V28.293Z",
    fill: "url(#paint1_linear_1813_120624)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.732 23.873H0V23.9595H43.732V23.873Z",
    fill: "url(#paint2_linear_1813_120624)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9319 14.2755C19.9633 14.6702 20.1924 14.9739 20.4436 14.9538C20.6947 14.9338 20.8728 14.5977 20.8413 14.2029C20.8309 14.045 20.7829 13.8919 20.7012 13.7564L20.547 12.0859L19.7646 12.175L19.9997 13.8124C19.9404 13.9591 19.9172 14.1179 19.9319 14.2755Z",
    fill: "url(#paint3_linear_1813_120624)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9961 6.48034C18.9961 6.48034 19.7274 6.09319 20.0983 6.67174C20.4691 7.25029 20.725 13.5074 20.725 13.5074L19.6972 13.6172L19.5024 9.20794L18.9961 6.48034Z",
    fill: "url(#paint4_linear_1813_120624)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4786 23.5468L18.0741 23.5468L18.3573 21.25L17.4785 21.2501L17.4786 23.5468Z",
    fill: "url(#paint5_linear_1813_120624)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5176 23.5351C19.5362 23.5663 19.546 23.6671 19.546 23.7034C19.546 23.815 19.4555 23.9055 19.3439 23.9055H17.4999C17.4237 23.9055 17.362 23.8438 17.362 23.7676V23.6909C17.362 23.6909 17.2708 23.4601 17.4586 23.1757C17.4586 23.1757 17.692 23.3984 18.0408 23.0496L18.1436 22.8633L18.8882 23.4078L19.3009 23.4586C19.3911 23.4697 19.4712 23.4569 19.5176 23.5351Z",
    fill: "url(#paint6_linear_1813_120624)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.924 23.4468L21.5009 23.2993L21.2069 21.0039L20.3555 21.2215L20.924 23.4468Z",
    fill: "url(#paint7_linear_1813_120624)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8966 22.928C22.9222 22.9537 22.9567 23.0489 22.9657 23.0841C22.9933 23.1922 22.928 23.3023 22.8199 23.3299L21.0332 23.7863C20.9595 23.8052 20.8844 23.7607 20.8655 23.6869L20.8465 23.6125C20.8465 23.6125 20.701 23.4115 20.8126 23.0895C20.8126 23.0895 21.0939 23.2475 21.3455 22.8232L21.399 22.6172L22.2552 22.9605L22.6676 22.9076C22.7578 22.896 22.8322 22.8637 22.8966 22.928Z",
    fill: "url(#paint8_linear_1813_120624)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9853 5.98624L16.957 5.78135L17.2926 4.96182L18.2145 4.85938L18.4136 6.03264L16.9853 5.98624Z",
    fill: "url(#paint9_linear_1813_120624)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.9853 5.98624L16.957 5.78135L17.2926 4.96182L18.2145 4.85938L18.4136 6.03264L16.9853 5.98624Z",
    fill: "url(#paint10_linear_1813_120624)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9098 11.7727L15.5 12.8995L15.8073 13.5142L17.3439 22.4266H18.3655L18.1634 14.5386L20.5195 22.4266H21.5306L20.7176 17.0996L20.1098 12.1824L19.7411 11.9547L17.9586 10.9531L15.9098 11.7727Z",
    fill: "url(#paint11_linear_1813_120624)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5211 12.5432L17.9064 12.6456L17.0869 10.6992H18.9308L18.5211 12.5432Z",
    fill: "url(#paint12_linear_1813_120624)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.752 12.0302L18.5227 12.5424L18.1129 11.6204L17.9081 12.6449L15.7568 11.9523L16.0642 10.6985L15.7568 6.60079L16.8417 5.87754L16.9861 5.78125L18.3178 5.88369L18.4346 5.94721L19.2398 6.3959L19.4447 9.77648L19.752 12.0302Z",
    fill: "url(#paint13_linear_1813_120624)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4338 5.94721L17.856 8.39352L16.8408 5.87754L16.9853 5.78125L18.317 5.88369L18.4338 5.94721Z",
    fill: "url(#paint14_linear_1813_120624)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4461 5.78125L17.2412 6.13411L17.4461 6.25172L17.3437 8.39988L17.7534 8.95695L18.1632 8.13362L17.8558 6.25172L17.9583 5.78125H17.4461Z",
    fill: "url(#paint15_linear_1813_120624)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7534 5.5753C18.2909 5.5753 18.7266 5.13959 18.7266 4.6021C18.7266 4.06462 18.2909 3.62891 17.7534 3.62891C17.216 3.62891 16.7803 4.06462 16.7803 4.6021C16.7803 5.13959 17.216 5.5753 17.7534 5.5753Z",
    fill: "url(#paint16_linear_1813_120624)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1304 4.68904L17.3407 4.78081L17.4324 4.23018C17.4324 4.23018 17.7995 4.04664 18.0748 4.13841C18.3501 4.23018 18.809 4.13841 18.809 4.13841C18.809 4.13841 18.809 3.2207 18.1666 3.2207C17.5242 3.2207 16.8818 3.31247 16.8818 3.58779C16.8818 3.8631 16.6065 4.13841 16.6065 4.13841C16.6065 4.13841 16.2394 4.68904 16.6065 5.05612C16.9736 5.4232 17.1571 5.4232 17.1571 5.4232L17.1304 4.68904Z",
    fill: "url(#paint17_linear_1813_120624)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2426 14.2447C15.2319 14.6405 15.4275 14.9668 15.6793 14.9735C15.9312 14.9803 16.144 14.6649 16.1546 14.269C16.161 14.111 16.1294 13.9536 16.0626 13.8102L16.0866 12.1328L15.2992 12.1383L15.3591 13.7914C15.2846 13.931 15.2447 14.0865 15.2426 14.2447Z",
    fill: "url(#paint18_linear_1813_120624)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2174 6.39411C16.2174 6.39411 15.5515 6.18923 15.2442 6.80388C14.9369 7.41853 15.3466 13.6675 15.3466 13.6675H16.3803L16.1059 9.26248L16.2174 6.39411Z",
    fill: "url(#paint19_linear_1813_120624)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7585 18.0377L39.2754 17.2775C39.2205 17.2607 39.1629 17.2546 39.1056 17.2594L26.5209 18.3305C26.3414 18.3458 26.2963 18.5878 26.4582 18.6667L26.8613 18.8631H26.8506V28.2646H27.2304V19.0429L28.4938 19.6584C28.5905 19.7055 28.6984 19.7247 28.8054 19.7139L28.9398 19.7003V28.2646H29.3196V19.662L39.0533 18.6787V28.2646H39.4332V18.6404L41.0475 18.4773V28.2646H41.4274V18.4389L41.7219 18.4092C41.9287 18.3883 41.9572 18.0985 41.7585 18.0377Z",
    fill: "url(#paint20_linear_1813_120624)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1748 18.2945C30.4122 18.2945 33.9258 17.8672 33.9258 17.8672L34.4481 18.5794L30.7921 19.2917L30.1748 18.2945Z",
    fill: "url(#paint21_linear_1813_120624)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0306 27.9012L33.4201 27.9001L33.1338 25.5449L34.0348 25.5465L34.0306 27.9012Z",
    fill: "url(#paint22_linear_1813_120624)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9395 27.8816C31.9204 27.9136 31.9102 28.0169 31.9102 28.0542C31.91 28.1686 32.0026 28.2615 32.117 28.2617L34.0075 28.2649C34.0855 28.2651 34.1489 28.2019 34.1491 28.1238L34.1492 28.0451C34.1492 28.0451 34.2431 27.8087 34.0511 27.5168C34.0511 27.5168 33.8114 27.7447 33.4544 27.3865L33.3493 27.1953L32.585 27.7522L32.1619 27.8036C32.0693 27.8148 31.9872 27.8015 31.9395 27.8816Z",
    fill: "url(#paint23_linear_1813_120624)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3084 26.805L36.8268 27.1683L35.1963 25.4834L35.9071 24.9473L37.3084 26.805Z",
    fill: "url(#paint24_linear_1813_120624)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6494 28.0392C35.6534 28.0758 35.707 28.1633 35.7292 28.1927C35.7973 28.2829 35.9257 28.3009 36.0159 28.2328L37.5074 27.1077C37.569 27.0612 37.5813 26.9736 37.5348 26.912L37.488 26.8499C37.488 26.8499 37.421 26.6076 37.0955 26.4922C37.0955 26.4922 37.0426 26.8147 36.5477 26.7454L36.3508 26.6575L36.0808 27.5522L35.7781 27.8451C35.7118 27.9092 35.6392 27.9476 35.6494 28.0392Z",
    fill: "url(#paint25_linear_1813_120624)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0308 14.6326C36.0308 15.1955 35.5744 15.6519 35.0115 15.6519C34.4485 15.6519 33.9922 15.1955 33.9922 14.6326C33.9922 14.0696 34.4485 13.6133 35.0115 13.6133C35.5744 13.6133 36.0308 14.0696 36.0308 14.6326Z",
    fill: "url(#paint26_linear_1813_120624)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9351 20.5101C35.9351 20.5101 32.1822 20.2977 31.9698 20.7226C31.7574 21.1474 33.1182 26.9834 33.1182 26.9834L34.3323 26.7289L33.74 22.6345C33.74 22.6345 36.8717 23.4639 37.2966 22.4725C37.7214 21.4812 37.5991 21.112 37.5991 21.112L35.9351 20.5101Z",
    fill: "url(#paint27_linear_1813_120624)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M36.897 19.7969C36.897 19.7969 33.2216 20.5848 33.1292 21.0507C33.0367 21.5166 35.8928 26.7847 35.8928 26.7847L36.9963 26.2181L35.3421 22.4262C35.3421 22.4262 38.5816 22.3976 38.7291 21.3292C38.8766 20.2608 38.661 19.9371 38.661 19.9371L36.897 19.7969Z",
    fill: "url(#paint28_linear_1813_120624)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3157 15.8008H35.5499L34.3417 17.7835C34.3417 17.7835 34.0585 19.0648 34.3417 19.203C34.6249 19.3413 34.6249 20.8283 34.6249 20.8283L37.5989 21.1116C37.5989 21.1116 38.0238 16.6505 37.8822 16.2256C37.7405 15.8008 37.3157 15.8008 37.3157 15.8008Z",
    fill: "url(#paint29_linear_1813_120624)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5181 17.1133L34.341 19.2055L32.3499 18.3605L31.8747 18.1215C31.7816 18.0001 31.6608 17.9028 31.5224 17.8377C31.1783 17.6699 30.8129 17.7115 30.7062 17.9304C30.5995 18.1494 30.7919 18.4628 31.1359 18.6304C31.2726 18.6993 31.4237 18.7345 31.5767 18.733L32.9671 19.5227L32.9687 19.5196L32.9749 19.5307L35.1553 20.4414L35.657 17.6947L34.5181 17.1133Z",
    fill: "url(#paint30_linear_1813_120624)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.305 14.7748C34.305 14.7748 33.2428 14.9164 33.6677 13.9958C33.6677 13.9958 33.6029 13.4968 33.9185 13.4631C34.2342 13.4294 34.659 12.8629 34.659 12.8629C34.659 12.8629 35.6331 12.3672 36.1374 12.8629C36.6417 13.3586 38.1287 16.2618 38.1287 16.2618L37.1373 17.324C37.1373 17.324 36.5414 15.7572 35.848 15.9387C35.1547 16.1202 34.5174 16.6613 34.5174 16.6613C34.5174 16.6613 33.8138 16.3092 34.1302 16.0022C34.4466 15.6953 34.305 14.7748 34.305 14.7748Z",
    fill: "url(#paint31_linear_1813_120624)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7214 16.3343C35.7214 16.3343 35.2257 15.697 34.8717 16.1927C34.5176 16.6883 34.2344 17.3256 34.2344 17.3256L35.6506 17.8213L35.7214 16.3343Z",
    fill: "url(#paint32_linear_1813_120624)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0996 28.1239L39.4543 22.8941L39.4545 22.8941H39.4583L39.4516 22.8856L39.4515 22.8854L39.3343 22.5129L39.3344 22.5128C39.5129 22.359 39.6344 22.1392 39.6587 21.8861L38.9066 17.7494C38.9583 17.2062 38.5419 16.7314 37.9963 16.7119L36.2994 16.7076C35.8169 16.6905 35.3991 17.0391 35.3288 17.5167L35.2913 17.7703L34.7714 21.3073C34.7524 21.4345 34.76 21.5599 34.7899 21.6772L34.4158 21.7261L34.3023 21.7413L33.8536 21.7997L33.8522 21.8001L33.7961 21.8073H33.7354V23.3267H33.7392V28.1832C33.7392 28.2145 33.7648 28.2402 33.7961 28.2402C33.8279 28.2402 33.8536 28.2145 33.8536 28.1832V23.3267H34.5193L35.1835 28.1775C35.1878 28.206 35.212 28.2269 35.2405 28.2269C35.2429 28.2269 35.2457 28.2269 35.2481 28.2264C35.2795 28.2221 35.3013 28.1932 35.297 28.1618L34.6351 23.3267H37.8292C38.1463 23.3267 38.4402 23.226 38.6795 23.0537L39.9459 28.1686C39.9525 28.1945 39.9758 28.2117 40.0013 28.2117C40.006 28.2117 40.0107 28.2111 40.0155 28.2099C40.0461 28.2021 40.0646 28.171 40.0568 28.1404L38.7781 22.976C38.7951 22.9619 38.8121 22.9468 38.8282 22.9312L39.3366 22.9013L40.9905 28.1583C40.9982 28.1827 41.0207 28.1983 41.045 28.1983C41.0507 28.1983 41.0565 28.1974 41.0622 28.1957C41.0924 28.1862 41.1091 28.154 41.0996 28.1239ZM39.2256 22.594C39.2299 22.5917 39.2337 22.5888 39.2375 22.5864L39.2498 22.6252L39.2256 22.594Z",
    fill: "url(#paint33_linear_1813_120624)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81641 19.2589L9.92374 18.5547L10.3739 18.8262L8.81641 20.616V19.2589Z",
    fill: "url(#paint34_linear_1813_120624)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30133 16.5339C7.30133 16.5339 6.56583 16.707 6.91195 17.7021C7.25807 18.6972 8.38295 20.774 8.72907 20.6442C9.07518 20.5144 9.11845 19.2164 9.11845 19.2164C9.11845 19.2164 9.07518 19.2597 8.90213 19.0866C8.72907 18.9136 8.72907 18.9926 8.72907 18.8016C8.72907 18.6107 8.58752 18.4691 8.58752 18.4691L8.42621 18.1348C8.42621 18.1348 8.42621 16.5772 7.77724 16.4907C7.12827 16.4042 7.30133 16.5339 7.30133 16.5339Z",
    fill: "url(#paint35_linear_1813_120624)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7377 18.7806C11.025 18.4933 11.114 18.1167 10.9366 17.9393C10.7592 17.7618 10.3825 17.8509 10.0953 18.1381C9.80804 18.4254 9.71901 18.802 9.89642 18.9794C10.0738 19.1568 10.4505 19.0678 10.7377 18.7806Z",
    fill: "url(#paint36_linear_1813_120624)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43945 22.2672L5.19505 23.5179L9.59836 23.2573L8.42588 21.7461L4.43945 22.2672Z",
    fill: "url(#paint37_linear_1813_120624)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75455 28.1166C5.7289 28.1166 5.70656 28.0976 5.70299 28.0715L4.38721 18.4616C4.3833 18.4331 4.40325 18.4068 4.43176 18.4029C4.46026 18.3988 4.48654 18.4189 4.49046 18.4474L5.80624 28.0574C5.81015 28.0859 5.7902 28.1122 5.76169 28.1161C5.75929 28.1164 5.75691 28.1166 5.75455 28.1166Z",
    fill: "url(#paint38_linear_1813_120624)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43883 28.1288C4.41005 28.1288 4.38672 28.1055 4.38672 28.0767V18.4564C4.38672 18.4276 4.41005 18.4043 4.43883 18.4043C4.46761 18.4043 4.49094 18.4276 4.49094 18.4564V28.0767C4.49094 28.1055 4.46761 28.1288 4.43883 28.1288Z",
    fill: "url(#paint39_linear_1813_120624)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0446 28.0906C11.0224 28.0906 11.0019 28.0764 10.9949 28.0542L7.88132 18.1576C7.87268 18.1302 7.88794 18.1009 7.91539 18.0922C7.94283 18.0836 7.97211 18.0989 7.98073 18.1263L11.0943 28.0229C11.103 28.0503 11.0877 28.0796 11.0602 28.0882C11.055 28.0899 11.0498 28.0906 11.0446 28.0906Z",
    fill: "url(#paint40_linear_1813_120624)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0936 28.1003C10.0703 28.1003 10.0491 28.0847 10.0431 28.0611L7.88052 19.3267C7.87344 19.2988 7.89029 19.2704 7.91818 19.2633C7.94616 19.2563 7.97444 19.2731 7.98154 19.301L10.1441 28.0354C10.1512 28.0633 10.1343 28.0916 10.1065 28.0987C10.1021 28.0998 10.0978 28.1003 10.0936 28.1003Z",
    fill: "url(#paint41_linear_1813_120624)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43945 18.6102L8.04808 18.5547L8.71249 22.3458H4.49156L4.43945 18.6102Z",
    fill: "url(#paint42_linear_1813_120624)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98073 24.1816L9.07129 25.7828L10.1272 26.0153L10.5675 24.8765L9.98073 24.1816Z",
    fill: "url(#paint43_linear_1813_120624)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40006 25.4797C9.40006 25.4797 9.36472 25.2185 9.15696 25.3014C8.94921 25.3843 8.34961 25.6922 8.34961 25.6922C8.34961 25.6922 9.9135 28.2334 10.2103 28.115C10.5071 27.9966 10.1518 27.2783 10.1518 27.2783L10.2302 26.0086L9.40006 25.4797Z",
    fill: "url(#paint44_linear_1813_120624)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95974 21.073C5.95974 21.073 5.63525 22.5656 6.63034 23.0848C7.62543 23.604 11.0217 22.3277 11.0217 22.3277L9.46418 24.6615L10.5458 25.0967C10.5458 25.0967 13.0119 21.8518 12.8388 21.3326C12.6658 20.8134 11.4976 20.7701 11.4976 20.7701L8.85848 20.8999L8.16624 20.6836L5.95974 21.073Z",
    fill: "url(#paint45_linear_1813_120624)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63871 24.8945L7.20898 26.055L8.10794 26.6558L8.93237 25.7552L8.63871 24.8945Z",
    fill: "url(#paint46_linear_1813_120624)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62316 25.8912C7.62316 25.8912 7.68526 25.6351 7.46159 25.6367C7.23793 25.6383 6.56738 25.707 6.56738 25.707C6.56738 25.707 7.09939 28.643 7.41891 28.6407C7.73843 28.6385 7.66888 27.8401 7.66888 27.8401L8.20394 26.686L7.62316 25.8912Z",
    fill: "url(#paint47_linear_1813_120624)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M6.02298 20.5352C6.02298 20.5352 5.1776 21.8074 5.91555 22.6531C6.6535 23.4988 10.2814 23.5458 10.2814 23.5458L7.98141 25.1529L8.83052 25.9518C8.83052 25.9518 12.3083 23.8268 12.336 23.2802C12.3637 22.7336 11.2914 22.2682 11.2914 22.2682L8.78597 21.4288L8.21991 20.9754L6.02298 20.5352Z",
    fill: "url(#paint48_linear_1813_120624)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19236 17.5886C8.19236 17.5886 7.37033 17.2857 6.98095 17.2857C6.94375 17.2857 6.90697 17.29 6.8702 17.2978C6.62099 17.3506 6.39169 17.5648 6.2818 17.6816C6.23896 17.7274 6.2143 17.7582 6.2143 17.7582C6.2143 17.7582 6.2169 17.7283 6.22209 17.676C6.24762 17.4008 6.34193 16.4978 6.5111 15.9198C6.57167 15.7134 6.64133 15.5486 6.72136 15.4685C6.90784 15.2816 6.99393 15.0575 7.03373 14.8905C7.06748 14.7473 7.06748 14.6465 7.06748 14.6465L6.75208 14.5106L6.69367 14.129C6.68329 14.174 6.63527 14.2619 6.47389 14.4302C6.46005 14.4444 6.4449 14.4566 6.42889 14.4669C6.19613 14.6132 5.72152 14.3588 5.46582 14.1987C5.57225 13.8288 5.76521 13.4904 6.11566 13.4351C6.93769 13.3053 6.93769 12.8293 7.45686 13.3485C7.4997 13.3914 7.54296 13.4325 7.58623 13.4723C7.75236 13.7898 7.81293 14.2156 7.83456 14.5115C7.85014 14.7187 7.84625 14.8628 7.84625 14.8628C7.84625 14.8628 8.06257 16.1608 8.40869 16.4204C8.75481 16.68 8.19236 17.5886 8.19236 17.5886Z",
    fill: "url(#paint49_linear_1813_120624)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59044 15.5117L6.00586 16.3692L7.32594 16.7232V15.5117H6.59044Z",
    fill: "url(#paint50_linear_1813_120624)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.59044 15.5117L6.00586 16.3692L7.32594 16.7232V15.5117H6.59044Z",
    fill: "url(#paint51_linear_1813_120624)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40917 16.3395L6.1545 15.8203C6.1545 15.8203 4.46717 16.5558 4.59697 17.9836C4.72676 19.4114 5.93817 21.8775 5.93817 21.8775L8.361 20.8391L8.10141 18.0701L7.40917 16.3395Z",
    fill: "url(#paint52_linear_1813_120624)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87353 15.8936C7.48487 15.8936 7.98046 15.398 7.98046 14.7866C7.98046 14.1753 7.48487 13.6797 6.87353 13.6797C6.26219 13.6797 5.7666 14.1753 5.7666 14.7866C5.7666 15.398 6.26219 15.8936 6.87353 15.8936Z",
    fill: "url(#paint53_linear_1813_120624)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36468 14.3869C8.14836 14.6032 7.9753 14.8196 7.9753 14.8196L7.88877 14.4734C7.88877 14.4734 7.86887 14.4881 7.83382 14.5115C7.69668 14.605 7.32849 14.8399 7.03299 14.8905C6.90147 14.913 6.78465 14.8987 6.70851 14.8196C6.54713 14.6512 6.49911 14.5634 6.48873 14.5184L6.43032 14.9L6.11492 15.0359C6.11492 15.0359 6.11492 15.5109 6.46103 15.8579C6.47791 15.8748 6.49435 15.8956 6.51036 15.9198C6.67563 16.169 6.79417 16.7791 6.86945 17.2978C6.93608 17.759 6.9681 18.1475 6.9681 18.1475C6.9681 18.1475 6.64058 17.7374 6.28105 17.6816C6.26115 17.6785 6.24125 17.6764 6.22135 17.6759C6.21486 17.6751 6.20794 17.6751 6.20145 17.6751C5.81206 17.6751 4.99003 17.9779 4.99003 17.9779C4.99003 17.9779 4.42759 17.0694 4.77371 16.8098C5.11983 16.5502 5.33615 15.2522 5.33615 15.2522C5.33615 15.2522 5.32187 14.6967 5.46508 14.1987C5.57151 13.8288 5.76447 13.4904 6.11492 13.4351C6.93695 13.3053 6.93695 12.8293 7.45612 13.3485C7.49896 13.3914 7.54222 13.4325 7.58549 13.4723C8.06918 13.917 8.56327 14.1883 8.36468 14.3869Z",
    fill: "url(#paint54_linear_1813_120624)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50973 20.1953H3.09863V28.3146H3.50973V20.1953Z",
    fill: "url(#paint55_linear_1813_120624)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4795 20.1953H13.0684V28.3146H13.4795V20.1953Z",
    fill: "url(#paint56_linear_1813_120624)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8593 16.75H8.13574V19.4736H10.8593V16.75Z",
    fill: "url(#paint57_linear_1813_120624)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M6.56641 19.6456L7.67374 18.9414L8.12394 19.213L6.56641 21.0027V19.6456Z",
    fill: "url(#paint58_linear_1813_120624)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05133 16.9207C5.05133 16.9207 4.31583 17.0937 4.66195 18.0888C5.00807 19.084 6.13295 21.1607 6.47907 21.0309C6.82518 20.9011 6.86845 19.6031 6.86845 19.6031C6.86845 19.6031 6.82518 19.6464 6.65213 19.4733C6.47907 19.3003 6.47907 19.3793 6.47907 19.1884C6.47907 18.9974 6.33752 18.8559 6.33752 18.8559L6.17621 18.5215C6.17621 18.5215 6.17621 16.9639 5.52724 16.8774C4.87827 16.7909 5.05133 16.9207 5.05133 16.9207Z",
    fill: "url(#paint59_linear_1813_120624)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48674 19.1653C8.77397 18.8781 8.863 18.5014 8.6856 18.324C8.50819 18.1466 8.13153 18.2356 7.8443 18.5229C7.55707 18.8101 7.46804 19.1868 7.64544 19.3642C7.82285 19.5416 8.19951 19.4526 8.48674 19.1653Z",
    fill: "url(#paint60_linear_1813_120624)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3019 19.8867H1.86621V20.8117H14.3019V19.8867Z",
    fill: "url(#paint61_linear_1813_120624)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9371 12.4863H25.1005C24.9549 12.4863 24.8369 12.6044 24.8369 12.7499V13.5074C24.8369 13.653 24.9549 13.771 25.1005 13.771H26.9371C27.0827 13.771 27.2007 13.653 27.2007 13.5074V12.7499C27.2007 12.6044 27.0827 12.4863 26.9371 12.4863Z",
    fill: "url(#paint62_linear_1813_120624)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7896 13.2441H28.9531C28.8075 13.2441 28.6895 13.3622 28.6895 13.5078V13.5078C28.6895 13.6533 28.8075 13.7714 28.9531 13.7714H30.7896C30.9352 13.7714 31.0533 13.6533 31.0533 13.5078C31.0533 13.3622 30.9352 13.2441 30.7896 13.2441Z",
    fill: "url(#paint63_linear_1813_120624)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1813_120624",
    x1: -7.87899,
    y1: 15.9348,
    x2: 45.2889,
    y2: -18.2747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1813_120624",
    x1: -14,
    y1: 28.3926,
    x2: -13.994,
    y2: 27.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1813_120624",
    x1: -14,
    y1: 23.9727,
    x2: -13.994,
    y2: 23.2421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1813_120624",
    x1: 19.4188,
    y1: 15.3914,
    x2: 21.5853,
    y2: 15.1962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1813_120624",
    x1: 18.4426,
    y1: 14.7226,
    x2: 21.9267,
    y2: 14.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1813_120624",
    x1: 17.1972,
    y1: 23.8964,
    x2: 18.9591,
    y2: 23.7351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1813_120624",
    x1: 16.6336,
    y1: 24.0641,
    x2: 20.183,
    y2: 22.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1813_120624",
    x1: 19.9888,
    y1: 23.8185,
    x2: 22.2758,
    y2: 23.5619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1813_120624",
    x1: 20.0657,
    y1: 23.9692,
    x2: 23.7699,
    y2: 22.3063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1813_120624",
    x1: 16.4907,
    y1: 6.2112,
    x2: 19.1967,
    y2: 5.40731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1813_120624",
    x1: 16.4907,
    y1: 6.2112,
    x2: 19.1967,
    y2: 5.40731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1813_120624",
    x1: 13.5694,
    y1: 24.1728,
    x2: 25.5717,
    y2: 22.6631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1813_120624",
    x1: 16.4966,
    y1: 12.9418,
    x2: 20.0423,
    y2: 12.138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1813_120624",
    x1: 14.4779,
    y1: 13.6894,
    x2: 22.4012,
    y2: 12.5858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1813_120624",
    x1: 16.3309,
    y1: 8.79108,
    x2: 19.4842,
    y2: 8.33094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1813_120624",
    x1: 16.9461,
    y1: 9.44026,
    x2: 18.801,
    y2: 9.31139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1813_120624",
    x1: 16.1572,
    y1: 5.87152,
    x2: 19.879,
    y2: 4.98091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1813_120624",
    x1: 15.6861,
    y1: 5.7584,
    x2: 20.1723,
    y2: 4.60536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1813_120624",
    x1: 14.9498,
    y1: 15.406,
    x2: 16.7852,
    y2: 15.2648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1813_120624",
    x1: 14.7296,
    y1: 14.7794,
    x2: 17.2533,
    y2: 14.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1813_120624",
    x1: 21.3852,
    y1: 29.9397,
    x2: 49.5764,
    y2: 20.4183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1813_120624",
    x1: 28.8068,
    y1: 19.5085,
    x2: 34.508,
    y2: 15.4156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1813_120624",
    x1: 32.8454,
    y1: 28.2598,
    x2: 34.6517,
    y2: 28.0945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1813_120624",
    x1: 31.186,
    y1: 28.4277,
    x2: 34.8268,
    y2: 26.5853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1813_120624",
    x1: 34.5201,
    y1: 27.5063,
    x2: 38.58,
    y2: 26.5824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1813_120624",
    x1: 35.0355,
    y1: 28.5453,
    x2: 38.6662,
    y2: 27.6118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1813_120624",
    x1: 33.3396,
    y1: 15.9621,
    x2: 37.2378,
    y2: 15.0293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1813_120624",
    x1: 30.1327,
    y1: 27.9766,
    x2: 41.1176,
    y2: 25.6936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1813_120624",
    x1: 31.317,
    y1: 27.8481,
    x2: 42.3342,
    y2: 25.7151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1813_120624",
    x1: 33.0329,
    y1: 21.9198,
    x2: 40.302,
    y2: 20.7095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1813_120624",
    x1: 29.0824,
    y1: 20.9479,
    x2: 38.0067,
    y2: 17.7521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1813_120624",
    x1: 32.1072,
    y1: 18.0364,
    x2: 40.8533,
    y2: 15.9972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1813_120624",
    x1: 33.7583,
    y1: 18.0979,
    x2: 36.6536,
    y2: 17.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1813_120624",
    x1: 31.377,
    y1: 29.9954,
    x2: 45.9307,
    y2: 27.7708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1813_120624",
    x1: 8.31779,
    y1: 20.9297,
    x2: 11.367,
    y2: 20.3783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1813_120624",
    x1: 6.08332,
    y1: 21.2875,
    x2: 10.6526,
    y2: 20.6874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1813_120624",
    x1: 9.98243,
    y1: 19.7314,
    x2: 11.1025,
    y2: 17.1946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1813_120624",
    x1: 2.78792,
    y1: 23.7875,
    x2: 9.80907,
    y2: 18.8954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1813_120624",
    x1: 3.93213,
    y1: 29.5949,
    x2: 6.79947,
    y2: 29.4946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1813_120624",
    x1: 4.35335,
    y1: 29.6088,
    x2: 4.56406,
    y2: 29.6082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1813_120624",
    x1: 6.84878,
    y1: 29.6127,
    x2: 13.3159,
    y2: 29.1147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1813_120624",
    x1: 7.15323,
    y1: 29.4455,
    x2: 11.7189,
    y2: 29.1653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1813_120624",
    x1: 3.07152,
    y1: 22.9227,
    x2: 11.1245,
    y2: 20.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1813_120624",
    x1: 8.59232,
    y1: 26.2943,
    x2: 11.506,
    y2: 25.7254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1813_120624",
    x1: 7.71608,
    y1: 28.5503,
    x2: 11.6083,
    y2: 27.8999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1813_120624",
    x1: 3.688,
    y1: 25.7683,
    x2: 15.976,
    y2: 21.1452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1813_120624",
    x1: 6.65727,
    y1: 26.9238,
    x2: 9.96036,
    y2: 26.1504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1813_120624",
    x1: 6.04347,
    y1: 29.0979,
    x2: 9.29683,
    y2: 28.6738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1813_120624",
    x1: 3.46095,
    y1: 26.7762,
    x2: 15.9515,
    y2: 23.0662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1813_120624",
    x1: 4.48768,
    y1: 18.4654,
    x2: 10.5157,
    y2: 17.5169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1813_120624",
    x1: 5.58326,
    y1: 16.9075,
    x2: 8.08217,
    y2: 16.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1813_120624",
    x1: 5.58326,
    y1: 16.9075,
    x2: 8.08217,
    y2: 16.2559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1813_120624",
    x1: 3.38258,
    y1: 22.7993,
    x2: 10.8412,
    y2: 21.6881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1813_120624",
    x1: 5.05788,
    y1: 16.2305,
    x2: 9.29124,
    y2: 15.2175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1813_120624",
    x1: 3.46109,
    y1: 18.914,
    x2: 10.8066,
    y2: 17.6056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1813_120624",
    x1: 2.96703,
    y1: 29.5503,
    x2: 3.79802,
    y2: 29.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1813_120624",
    x1: 12.9368,
    y1: 29.5503,
    x2: 13.7677,
    y2: 29.5402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1813_120624",
    x1: 7.26386,
    y1: 19.8881,
    x2: 12.4718,
    y2: 18.6418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1813_120624",
    x1: 6.06779,
    y1: 21.3164,
    x2: 9.11697,
    y2: 20.7651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1813_120624",
    x1: 3.83332,
    y1: 21.6742,
    x2: 8.40264,
    y2: 21.0741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1813_120624",
    x1: 7.73145,
    y1: 20.1162,
    x2: 8.85152,
    y2: 17.5793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1813_120624",
    x1: -2.11483,
    y1: 20.9525,
    x2: 0.100222,
    y2: 13.8263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1813_120624",
    x1: 24.0802,
    y1: 13.9665,
    x2: 28.0831,
    y2: 12.2041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1813_120624",
    x1: 27.9327,
    y1: 13.8516,
    x2: 30.1544,
    y2: 11.4681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentLifeSectionIcon);
export default __webpack_public_path__ + "static/media/student-life-section-icon.de42edb21119d401d0de7f623484139a.svg";
export { ForwardRef as ReactComponent };